export default __webpack_public_path__ + "static/modernStack-057e545b15d14404d020103447a3b735.mp4";